import styled from "styled-components";
import device from "src/constants/media";
import { typography, colors } from "src/theme";

export const DateContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: fit-content;
  padding: 12px 28px 12px 12px;
  border: 2px solid ${colors.greyVeryLight};
  box-sizing: border-box;
  border-radius: 8px;
  cursor: pointer;
  background: ${colors.white};
  @media ${device.tablet} {
    padding: 20px 36px 20px 20px;
  }
`;
export const CalendarContainer = styled.div`
  width: 40px;
  height: 40px;
`;
export const TimeText = styled.p`
  margin: 0 41px 0 12px;
  font-family: ${typography.fontFamily};
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  color: ${colors.greyDark};
  @media ${device.tablet} {
    margin: 0 26px 0 12px;
    font-size: 24px;
    line-height: 32px;
  }
`;
export const ArrowDown = styled.div`
  width: 12px;
  height: 7px;
  display: flex;
  align-items: center;
`;
export const DropdownContentTime = styled.div`
  width: 100%;
  border-radius: 8px;
  cursor: pointer;
  position: absolute;
  bottom: -138px;
  left: 0;
  color: ${colors.grey};
  background-color: ${colors.white};
  box-shadow: 0px 8px 64px -32px rgba(0, 0, 0, 0.2);
  z-index: 1;
  @media ${device.tablet} {
    bottom: -170px;
  }
`;
export const DropdownItem = styled.div`
  margin-left: 14px;
  font-family: ${typography.fontFamily};
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  color: ${colors.greyDark};
  @media ${device.tablet} {
    font-size: 24px;
    line-height: 32px;
  }
`;
export const DropdownContainerFirst = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 12px 28px 12px 12px;
  box-sizing: border-box;
  border-radius: 8px 8px 0 0;
  cursor: pointer;
  @media ${device.tablet} {
    padding: 20px 36px 20px 20px;
  }
  :hover {
    background: ${colors.mainLight};
  }
`;
export const DropdownContainerSecond = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 12px 28px 12px 12px;
  box-sizing: border-box;
  border-radius: 0 0 8px 8px;
  cursor: pointer;
  @media ${device.tablet} {
    padding: 20px 36px 20px 20px;
  }
  :hover {
    background: ${colors.mainLight};
  }
`;
